<app-context-menu-heading>Sorting options:</app-context-menu-heading>
<app-context-menu-item
  title="Relevance"
  [withCheckOption]="true"
  [active]="state.sortBy === 'score'"
  [sortable]="true"
  [reversed]="state.sortOrder === 'desc'"
  (execute)="sort('score')"
/>
<app-context-menu-item
  title="Title"
  [withCheckOption]="true"
  [active]="state.sortBy === 'title'"
  [sortable]="true"
  [reversed]="state.sortOrder === 'desc'"
  (execute)="sort('title')"
/>
<app-context-menu-item
  title="Created date"
  [withCheckOption]="true"
  [active]="state.sortBy === 'createdAt'"
  [sortable]="true"
  [reversed]="state.sortOrder === 'desc'"
  (execute)="sort('createdAt')"
/>
<app-context-menu-item
  title="Updated date"
  [withCheckOption]="true"
  [active]="state.sortBy === 'updatedAt'"
  [sortable]="true"
  [reversed]="state.sortOrder === 'desc'"
  (execute)="sort('updatedAt')"
/>
<app-context-menu-divider />
<app-context-menu-item
  title="Pinned on top"
  [withCheckOption]="true"
  [active]="state.pinnedOnTop"
  (execute)="pinnedOnTop()"
/>
<app-context-menu-item
  title="Flagged on top"
  [withCheckOption]="true"
  [active]="state.flaggedOnTop"
  (execute)="flaggedOnTop()"
/>
<app-context-menu-heading>Filters:</app-context-menu-heading>
<app-stitch-type-context-menu-item
  title="Stitch"
  [withCheckOption]="true"
  [state]="state.stitchedWith"
  (onSelect)="stitch($event)"
/>
<app-context-menu-divider />
<app-context-menu-item title="Flagged" [withCheckOption]="true" [active]="state.flagged" (execute)="flag()" />
<app-context-menu-item title="Pinned" [withCheckOption]="true" [active]="state.pinned" (execute)="pin()" />
<app-context-menu-item
  [withCheckOption]="true"
  [active]="!!(state.from || state.to)"
  title="Selected date"
  >
  <div class="date">
    <div class="date-buttons">
      <div
        class="date-buttons-item"
        [class.selected]="dateButtonSelected === 'from'"
        [class.active]="innerFromDate?.value"
        (click)="dateButtonSelected = 'from'"
        >
        <app-icon class="date-buttons-item-icon" name="sapphire-events" [size]="16" />
        <span class="date-buttons-item-text">{{ innerFromDate?.value ? (innerFromDate?.value | dateFormat:'date') : 'After'}}</span>
      </div>
      <div
        class="date-buttons-item"
        [class.selected]="dateButtonSelected === 'to'"
        [class.active]="innerToDate?.value"
        (click)="dateButtonSelected = 'to'"
        >
        <app-icon class="date-buttons-item-icon" name="sapphire-events" [size]="16" />
        <span class="date-buttons-item-text">{{ innerToDate?.value ? (innerToDate?.value | dateFormat:'date') : 'Before'}}</span>
      </div>
    </div>

    <app-date-picker-2
      [flush]="true"
      [inputFormControl]="dateButtonSelected === 'from' ? innerFromDate : innerToDate"
      [collapseable]="false"
      [maxDate]="dateButtonSelected === 'from' && innerToDate?.value"
      [minDate]="dateButtonSelected === 'to' && innerFromDate?.value"
      [highlightRange]="true"
      />

    @if (!!(state.from || state.to)) {
      <div class="flex justify-end pt-2">
        <app-button2 appearance="primary-text" size="s" (click)="clearSelectedDate()">Clear</app-button2>
      </div>
    }
    </div>
  </app-context-menu-item>
